import type { UnknownObject } from '~/shared/interfaces'
import type { Serializable } from '~/shared/interfaces/serializable'

export function isString(value: unknown): value is string {
  return typeof value === 'string'
}

export function isUnknownObject(data: unknown): data is UnknownObject {
  return typeof data === 'object' && data !== null && !Array.isArray(data)
}

export function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0
}

export function isNumber(value: unknown): value is number {
  return typeof value === 'number'
}

export function isArray(value: unknown): value is unknown[] {
  return Array.isArray(value)
}

export function isNonEmptyArray(value: unknown): value is [unknown, ...unknown[]] {
  return Array.isArray(value) && value.length > 0
}

export function isBoolean(value: unknown): value is boolean {
  return typeof value === 'boolean'
}

export function isExcludePrimitive<T extends string | number | symbol>(
  exclude: T,
  target: Array<T>
): exclude is Exclude<T, typeof exclude> {
  return !target.includes(exclude)
}

export function isSerializable(data: unknown): data is Serializable {
  return isUnknownObject(data) && typeof data.serialize === 'function'
}
